import React, { useEffect, useState } from "react";
import EventDisplay from "../components/EventDisplay";
import { useNavigate } from "react-router-dom";

const PublicView = ({ isDemo }) => {
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleClick = () => {
    if (isDemo) {
      localStorage.setItem("userEmail", "demo@example.com"); // ✅ Přidat znovu při kliknutí
    }
    navigate("/admin");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey((prevKey) => prevKey + 1);
    }, 15000);
    return () => clearInterval(interval);
  }, []);
  //Refresh prohlížeče kvůli změnám
  useEffect(() => {
    const reloadInterval = setInterval(() => {
      window.location.reload();
    }, 5 * 60 * 1000); // každých 5 minut

    return () => clearInterval(reloadInterval);
  }, []);

  return (
    <div className="relative min-h-screen">
      {/* Tlačítko v pravém horním rohu */}
      <div className="absolute top-4 right-4">
        <button type="button" onClick={handleClick} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded shadow">
          {isDemo ? "Přejít do administrace" : "Přihlásit"}
        </button>
      </div>

      {/* Výpis událostí */}
      <EventDisplay />
    </div>
  );
};

export default PublicView;
